module.exports = __webpack_public_path__ + "img/light.56ec9a66.png";